export default "__VITE_ASSET__6K4wmxng__"